import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as api from "./api";

const listKey = ["portal", "notification-campaigns"] as const;

export const useNotificationCampaigns = () =>
  useQuery({
    queryKey: listKey,
    queryFn: () => api.listNotificationCampaigns(),
  });

export const useNotificationCampaign = (id: string | null) =>
  useQuery({
    queryKey: ["portal", "notification-campaign", id],
    queryFn: () => api.getNotificationCampaign(id!),
    enabled: Boolean(id),
  });

export const useActiveMembers = (search: string, enabled: boolean) =>
  useQuery({
    queryKey: ["portal", "notification-active-members", search],
    queryFn: () => api.listActiveMembers(search),
    enabled,
    staleTime: 15_000,
  });

export function useNotificationMutations() {
  const client = useQueryClient();
  return {
    create: useMutation({
      mutationFn: ({
        input,
        idempotencyKey,
      }: {
        input: api.NotificationCampaignInput;
        idempotencyKey: string;
      }) => api.createNotificationCampaign(input, idempotencyKey),
      onSuccess: () => {
        client.invalidateQueries({ queryKey: listKey });
      },
    }),
  };
}
